import { useEffect } from "react";
import { useForm } from "../../useForm";
import SetupSlideOverFormActions from "../SetupSlideOverFormActions";
import { useSlideOverSubmit } from "../useSlideOverSubmit";

import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import Input from "../../../controls/Input";

const initialFValues = {
  name: "",
  contact: "",
  address: "",
  city: "",
  zip: "",
  state: "",
  country: "",
  phone: "",
  fax: "",
};

function customerToFormValues(customer) {
  if (!customer) return { ...initialFValues };
  return {
    name: customer.name ?? "",
    contact: customer.contact ?? "",
    address: customer.ship_addr_line1 ?? customer.address ?? "",
    city: customer.ship_addr_city ?? customer.city ?? "",
    zip: customer.ship_addr_postal_code ?? customer.zip ?? "",
    state: customer.ship_addr_country_sub_division_code ?? customer.state ?? "",
    // country: customer.ship_addr_country ?? customer.country ?? "",
    phone: customer.phone ?? "",
    fax: customer.fax ?? "",
  };
}

export default function CustomerDetailsForm(props) {
  const { index, customer, setOpen, actionCall, isEdit } = props;

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, false);
  const { submitting, runSubmit } = useSlideOverSubmit();

  const handleSubmit = (e) => {
    e.preventDefault();
    runSubmit(async () => {
      if (isEdit) {
        await actionCall(customer, values, index);
      } else {
        await actionCall(values);
      }
    });
  };

  useEffect(() => {
    if (isEdit && customer) {
      setValues(customerToFormValues(customer));
    }
  }, [customer, isEdit, setValues]);

  return (
    <div className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
        <div className="px-4 sm:px-6">
          <div className="flex items-start justify-between">
            <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
              {isEdit ? "Editing Customer" : "Add new customer"}
            </Dialog.Title>
            <div className="ml-3 flex h-7 items-center">
              <button
                type="button"
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                onClick={() => setOpen({ childComponent: null, open: false })}
              >
                <span className="sr-only">Close panel</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
        <div className="relative mt-6 flex-1 px-4 sm:px-6">
          <div>
            <div className="mt-2">
              <Input
                label="Company Name"
                name="name"
                onChange={handleInputChange}
                value={values.name}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
            </div>
            <div className="mt-2">
              <Input
                label="Contact Name"
                name="contact"
                onChange={handleInputChange}
                value={values.contact}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
            </div>
            {/* <div className="mt-2">
              <Input
                label="External id"
                name="external_id"
                onChange={handleInputChange}
                value={values.external_id}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
            </div> */}
            <div className="mt-2">
              <Input
                label="Address"
                name="address"
                onChange={handleInputChange}
                value={values.address}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
            </div>
            <div className="mt-3 grid grid-cols-2 gap-4">
              <div>
                <Input
                  label="City"
                  name="city"
                  onChange={handleInputChange}
                  value={values.city}
                  labelOn={true}
                  type="text"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                />
              </div>
              <Input
                label="Zip"
                name="zip"
                onChange={handleInputChange}
                value={values.zip}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
            </div>
            <div className="mt-3 grid grid-cols-2 gap-4">
              <div>
                <Input
                  label="State"
                  name="state"
                  onChange={handleInputChange}
                  value={values.state}
                  labelOn={true}
                  type="text"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                />
              </div>
              <div>
                <Input
                  label="Phone"
                  name="phone"
                  onChange={handleInputChange}
                  value={values.phone}
                  labelOn={true}
                  type="text"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                />
              </div>
              {/* <div>
                <Input
                  label="Country"
                  name="country"
                  onChange={handleInputChange}
                  value={values.country}
                  labelOn={true}
                  type="text"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                />
              </div> */}
            </div>
            <div className="mt-3 grid grid-cols-2 gap-4">
              <div>
                <Input
                  label="Fax"
                  name="fax"
                  onChange={handleInputChange}
                  value={values.fax}
                  labelOn={true}
                  type="text"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <SetupSlideOverFormActions
        setOpen={setOpen}
        isEdit={isEdit}
        submitting={submitting}
        onSubmit={handleSubmit}
      />
    </div>
  );
}
